import { ready } from '~/core';
import { media } from '~/utils';
ready('sliderMain', '.sliderMain', sliderMain => {
	const $timing = 400; // $timing in this file must also match $timing in _slider.scss
	let $autoTime = 8500; // change $autoTime to make the time inbetween automatic slides longer or shorter, set to 0 to disable
	//check if slider has autoslide class applied
	const doAuto = sliderMain.classList.contains('sliderMain--autoSlide');
	//check if slides have title data attribute to do titles
	// const doTitles = sliderMain.querySelector('.sliderMain-slide').dataset.title;
	const slideContainer = sliderMain.querySelector('.sliderMain-slides');
	const slides = [...slideContainer.querySelectorAll('.sliderMain-slide')];
	const navContainer = sliderMain.querySelector('.sliderMain-slideNav');
	const dotContainer = sliderMain.querySelector('.sliderMain-slideBullets');
	let navs = [],
		dots = [];
	let total, active, next, prev, dir, timer;

	const dotClick = dot => {
		if (!sliderMain.classList.contains('is-changing')) {
			next = dots.indexOf(dot);
			dir = next > active ? 'next' : next < active ? 'prev' : dir;
			slide(true);
		}
	};

	const createDots = () => {
		slides.forEach((slide, i) => {
			let dot = `<div class="sliderMain-slideBullet" ${
				i + 1 == 1 ? `data-current="${i + 1}"` : ''
			}>${i + 1}</div>`;
			dotContainer.insertAdjacentHTML('beforeend', dot);
		});
		dots = [...dotContainer.querySelectorAll('.sliderMain-slideBullet')];
		dots[0].classList.add('is-active');
		dots.forEach(dot => dot.addEventListener('click', () => dotClick(dot)));
		dots.forEach(dot =>
			dot.addEventListener('keydown', e => (e.code == 'Enter' ? dotClick(dot) : false))
		);
	};

	const navClick = nav => {
		if (!sliderMain.classList.contains('is-changing')) {
			if (nav.classList.contains('sliderMain-slideNavBtn--next')) {
				dir = 'next';
				next = active < total ? active + 1 : 0;
			} else {
				dir = 'prev';
				next = active > 0 ? active - 1 : total;
			}
			slide(true);
		}
	};

	const createNavs = () => {
		let nav = `<button class="sliderMain-slideNavBtn sliderMain-slideNavBtn--prev" aria-label="slider_prev"><span class='sliderMain-slideNavBtnText'>Previous</span></button><button class="sliderMain-slideNavBtn sliderMain-slideNavBtn--next" aria-label="slider_next"><span class='sliderMain-slideNavBtnText'>Next</span></button>`;
		navContainer.insertAdjacentHTML('beforeend', nav);
		navs = [...navContainer.querySelectorAll('.sliderMain-slideNavBtn')];
		navs.forEach(nav => nav.addEventListener('click', () => navClick(nav)));
		navs.forEach(nav =>
			nav.addEventListener('keydown', e => (e.code == 'Enter' ? navClick(nav) : false))
		);
	};

	const slideFocus = function(e) {
		slideContainer.scrollLeft = 0;
		setTimeout(() => {
			slideContainer.scrollLeft = 0;
		}, 0);
		if (!sliderMain.classList.contains('is-changing')) {
			dir = 'next';
			next = slides.indexOf(this);
			if (active !== next) slide(true);
		}
	};

	const setTimer = () => {
		clearInterval(timer);
		timer = setInterval(() => {
			if (!sliderMain.matches(':focus-within')) {
				dir = 'next';
				next = active < total ? active + 1 : 0;
				slide();
			}
		}, $autoTime);
	};

	const slide = (click = false) => {
		sliderMain.classList.add('is-changing');
		slides.forEach(slide => slide.classList.remove('is-initial'));
		slides[active].classList.add(`is-leaving--${dir}`);
		slides[active].classList.add('is-leaving');
		slides[active].classList.remove('is-active');
		slides[active].classList.remove('is-active--next');
		slides[active].classList.remove('is-active--prev');
		slides[next].classList.add(`is-active--${dir}`);
		slides[next].classList.add('is-active');

		prev = active;
		active = next;

		setTimeout(() => {
			slides[prev].classList.remove('is-leaving');
			slides[prev].classList.remove('is-leaving--next');
			slides[prev].classList.remove('is-leaving--prev');
			navs.forEach(nav => nav.classList.remove('is-inactive'));
			sliderMain.classList.remove('is-changing');
			if (click && doAuto) setTimer();
		}, $timing * 2);
	};

	const init = () => {
		total = slides.length - 1;
		active = 0;
		if (total) {
			if (dotContainer) createDots();
			if (navContainer) createNavs();
			if (doAuto) setTimer();
		}
		slides[0].classList.add('is-active');
		slides[0].classList.add('is-initial');
		slides.forEach(slide => {
			let img = slide.querySelector('.sliderMain-img');
			if (media.md.matches) {
				img.style.backgroundImage = "url('" + slide.dataset.bg + "')";
			} else {
				img.style.backgroundImage = '';
			}
		});
		slides.forEach(slide => slide.addEventListener('mousemove', setTimer));
		slides.forEach(slide => slide.addEventListener('mouseout', setTimer));
		slides.forEach(slide => slide.addEventListener('focusin', slideFocus));
	};
	init();
});
